import AnalyticsPage from '~/components/Content/Analytics/AnalyticsPage';
import DestinationImagePage from '~/components/Content/DestinationImage/DestinationImagePage';
import ManualExperienceLocationList from '~/components/Content/ManualExperienceLocations/ManualExperienceLocationList';
import PolygonMergeContainer from '~/components/Content/PolygonMerge/PolygonMergeContainer';
import PropertyLocationOverrideList from '~/components/Content/PropertyLocationOverride/PropertyLocationOverrideList';
import ReproduceSearchPage from '~/components/Content/ReproduceSearch/ReproduceSearchPage';
import RestoreSearchDashboard from '~/components/Content/RestoreSearchDashboard/RestoreSearchDashboard';
import TrendingPlacesPage from '~/components/Content/TrendingPlaces/TrendingPlacesPage';

import GeometrySearch from './GeometrySearch';
import DeprioritisedPolygonsPage from './GeometrySearch/DeprioritisedPolygonsPage';
import OfferListOrder from './OfferListOrder/OfferListOrderContainer';
import SearchRankingPage from './SearchRanking/SearchRankingPage';

export const curationTabs = {
  'offer-list-order': {
    title: 'Offer List Order',
    component: OfferListOrder,
  },
  'trending-places': {
    title: 'Trending Places',
    component: TrendingPlacesPage,
  },
  'destination-image': {
    title: 'Destination Image',
    component: DestinationImagePage,
  },
  'manual-experience-locations': {
    title: 'Manual Experience Locations',
    component: ManualExperienceLocationList,
  },
} as const;

export const searchCurationTabs = {
  'search-dashboard': {
    title: 'Search Dashboard',
    component: GeometrySearch,
  },
  'search-ranking': {
    title: 'Search Ranking',
    component: SearchRankingPage,
  },
  analytics: {
    title: 'Analytics',
    component: AnalyticsPage,
  },
  'reproduce-search': {
    title: 'Reproduce a search',
    component: ReproduceSearchPage,
  },
  'property-location-override': {
    title: 'Property Location Override',
    component: PropertyLocationOverrideList,
  },
  'restore-search-dashboard': {
    title: 'Restore Search Dashboard',
    component: RestoreSearchDashboard,
  },
  'polygon-merge': {
    title: 'Polygon Merge',
    component: PolygonMergeContainer,
  },
  'deprioritised-polygon': {
    title: 'Deprioritised Polygon',
    component: DeprioritisedPolygonsPage,
  },
} as const;

export const curationTabsList = Object.keys(curationTabs);
export const searchCurationTabsList = Object.keys(searchCurationTabs);

export type CurationTab = keyof typeof curationTabs;
export type SearchCurationTab = keyof typeof searchCurationTabs;
